import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Instagram = createReactComponent("Instagram", ["svg", defaultAttributes, [["rect", {
  x: "2",
  y: "2",
  width: "20",
  height: "20",
  rx: "5",
  ry: "5",
  key: "1wj0nt"
}], ["path", {
  d: "M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z",
  key: "6dhq4m"
}], ["line", {
  x1: "17.5",
  y1: "6.5",
  x2: "17.51",
  y2: "6.5",
  key: "1x6ige"
}]]]);
export default Instagram;